import * as React from "react";
import { forwardRef } from "react";
const SvgProfitLoss = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-chart-no-axes-column", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("line", { x1: 18, x2: 18, y1: 20, y2: 10 }), /* @__PURE__ */ React.createElement("line", { x1: 12, x2: 12, y1: 20, y2: 4 }), /* @__PURE__ */ React.createElement("line", { x1: 6, x2: 6, y1: 20, y2: 14 }));
const ForwardRef = forwardRef(SvgProfitLoss);
export { ForwardRef as ReactComponent };
